import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from '../shared/shared.module';
import { LoadingStateModule, StatsCardModule } from '@seniorsistemas/angular-components';
import { SStatsCardEmployeeExaminationComponent } from './s-stats-card-employee-examination.component';
import { SStatsCardEmployeeExaminationService } from './s-stats-card-employee-examination.service';

@NgModule({
    imports: [
        CommonModule,
        StatsCardModule,
        HttpClientModule,
        SharedModule,
        LoadingStateModule
    ],
    declarations: [SStatsCardEmployeeExaminationComponent],
    providers: [SStatsCardEmployeeExaminationService],
    exports: [SStatsCardEmployeeExaminationComponent]
})
export class SStatsCardEmployeeExaminationModule { }
